import { render, staticRenderFns } from "./Kantor.vue?vue&type=template&id=346c3f3a&scoped=true"
import script from "./Kantor.vue?vue&type=script&lang=js"
export * from "./Kantor.vue?vue&type=script&lang=js"
import style0 from "./Kantor.vue?vue&type=style&index=0&id=346c3f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346c3f3a",
  null
  
)

export default component.exports